import type { Organization } from "@/model/app/organization"
import type { PurchasableItem } from "@/model/order/purchasable-item"

export function useShopPricing(organizationId?: string) {
    function getBestPrice(item: PurchasableItem, amount = 1): number | null {
        if (!item.activePrices?.length) {
            return null
        }

        const applicablePrices = item.activePrices.filter(price => {
            if (price.pricePerUnitInCents === null || price.pricePerUnitInCents === undefined) {
                return false
            }

            if ((price.minQuantity ?? 0) > amount) {
                return false
            }

            if (price.maxQuantity != null && price.maxQuantity < amount) {
                return false
            }

            const organizations: Organization[] = price.organizations ?? []
            return organizations.length === 0 || organizations.some(organization => organization.id === organizationId)
        })

        if (!applicablePrices.length) {
            return null
        }

        return applicablePrices.reduce(
            (best, price) => Math.min(best, price.pricePerUnitInCents!),
            applicablePrices[0].pricePerUnitInCents!,
        )
    }

    return { getBestPrice }
}
